import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  Button,
  useTheme,
  Link,
  useMediaQuery,
  CircularProgress,
} from "@mui/material";
import ArrowBacIcon from "@mui/icons-material/ArrowBack";
import { MuiOtpInput } from "mui-one-time-password-input";
import { useSnackbar } from "notistack";

import { useNavigate } from 'react-router-dom';
import { axiosInstance as axios, endpoint } from "../../api/axios";
import { useSelector } from 'react-redux';
import DrGadgetLogo from '../../assets/img/dr-gadget.png';
import UpdatePinDialog from "../dialog/UpdatePinDialog";
import { useLocation } from 'react-router-dom';


  const ForgotPin = () => {

  const [dataOtp, setDataOtp] = useState({otp: "", tokenOtp: ""});
  const [loading, setLoading] = useState(false);
  const [openUpdatePinDialog, setOpenUpdatePinDialog] = useState(false);
  const [resendCooldown, setResendCooldown] = useState(0);
  const { enqueueSnackbar } = useSnackbar();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
   const navigate = useNavigate();
   const location = useLocation();

    const currentUserId = useSelector(state => state.user.currentUserId);
    const user = useSelector(state => state.user.users[state.user.currentUserId]);

  const handleChange = (value) => {
    setDataOtp({...dataOtp, otp : value});
  };

  const handleResend = async () => {
    if (resendCooldown > 0) return;

    try{

      if(user?.email != "" && currentUserId != null){
        const response = await axios.post(endpoint.forgotPin.requestOtp, {email : user?.email}, 
          { headers:  {"Content-Type": "application/json"}
        });
        setDataOtp({tokenOtp: response.data?.data?.tokenOtp })
      }
      enqueueSnackbar("OTP dikirim !", { variant: "info" });
      setResendCooldown(45);

    }catch(error){
      enqueueSnackbar("Email tidak sesuai!", { variant: "error" });
      console.log("API Request Otp", error.status)

    }

    
   
  };

  const handleBackToPin= () => {
     
      navigate('/pin'); 
    };

    const handleOpenUpdateDialog= () => {
     
      setOpenUpdatePinDialog(true) 
    };

    const handleCloseUpdateDialog= () => {
     
      setOpenUpdatePinDialog(false) 
    };

    const hasTriggeredRef = useRef(false);

    useEffect(() => {
      if (location.state?.triggerResend && !hasTriggeredRef.current) {
        hasTriggeredRef.current = true; 
        handleResend();
      }
    }, []);


  useEffect(() => {
    if (dataOtp?.otp && dataOtp.otp.length === 6) {
      setLoading(true);
      setTimeout(() => {
        setLoading(false);
        if (dataOtp?.otp != "") {
          handleOpenUpdateDialog();
          enqueueSnackbar("Silahkan Ubah Pin Anda!", { variant: "warning" });
        } else {
          enqueueSnackbar("OTP tidak boleh kosong", { variant: "error" });
        }
      }, 1500);
    }
  }, [dataOtp?.otp, user, enqueueSnackbar]);


  

  
  useEffect(() => {
    if (resendCooldown === 0) return;
    const timer = setInterval(() => {
      setResendCooldown((prev) => prev - 1);
    }, 1000);
    return () => clearInterval(timer);
  }, [resendCooldown]);

  

  

  return (
    <>
      <Box
        sx={{
          position: "absolute",
          top: 30,
          width: "100%",
          textAlign: "center",
          zIndex: 10,
        }}
      >
        <img
        src={DrGadgetLogo} 
        alt="Dr Gadget Indonesia"
        style={{
          width: isMobile ? "80%" : "60%", 
          maxWidth: "15%",
          height: "auto",
          objectFit: "contain",
          boxShadow: "0 0 6px rgba(211, 205, 205, 0.5)",
        }}
      />
      </Box>

      <Box
        sx={{
          minHeight: "100vh",
          backgroundImage: "url('/background.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          p: isMobile ? 1 : 3,
        }}
      >
        <Container maxWidth="sm">
          <Paper
            elevation={isMobile ? 1 : 3}
            sx={{
              p: isMobile ? 2 : 5,
              borderRadius: isMobile ? 2 : 4,
              backgroundColor: "rgba(255, 255, 255, 0.8)",
              position: "relative",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleBackToPin}
              startIcon={<ArrowBacIcon />}
              sx={{
                position: "absolute",
                top: isMobile ? 8 : 16,
                left: isMobile ? 8 : 16,
                borderRadius: 999,
                textTransform: "none",
              }}
            >
            </Button>

            <Box sx={{ mt: 4 }}>
              <Typography
                variant={isMobile ? "h6" : "h6"}
                gutterBottom
                sx={{
                  fontWeight: 500,
                  color: "text.secondary",
                  textAlign: "center",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                Masukkan kode verifikasi yang dikirim ke {user.email}
              </Typography>

              <Box sx={{ mb: isMobile ? 2 : 3, position: "relative" }}>
                <MuiOtpInput
                  value={dataOtp?.otp}
                  onChange={handleChange}
                  length={6}
                  TextFieldsProps={{
                    inputProps: {
                      inputMode: "numeric",
                    },
                    onInput: (e) => {
                      e.target.value = e.target.value.replace(/[^0-9]/g, "");
                    },
                    sx: {
                      width: isMobile ? 36 : 44,
                      height: isMobile ? 42 : 48,
                      mx: 0.5,
                    },
                  }}
                  sx={{ justifyContent: "center", mb: isMobile ? 2 : 3 }}
                />
                {loading && (
                  <CircularProgress
                    size={50}
                    sx={{
                      position: "absolute",
                      right: "50%",
                      top: "50%",
                      transform: "translate(50%, -50%)",
                    }}
                  />
                )}
              </Box>

              <Typography
                variant="body2"
                align="center"
                sx={{
                  mb: isMobile ? 1.5 : 2,
                  fontSize: isMobile ? 14 : 16,
                  display: "flex",
                  justifyContent: "center",
                  gap: 1,
                }}
              >
                Tidak menerima OTP?
                <Link
                  component="button"
                  underline="hover"
                  color={resendCooldown > 0 ? "text.disabled" : "text.secondary"}
                  onClick={handleResend}
                  disabled={resendCooldown > 0}
                  sx={{ pointerEvents: resendCooldown > 0 ? "none" : "auto" }}
                >
                  Kirim ulang
                </Link>
                {resendCooldown > 0 && (
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    component="span"
                  >
                    dalam ({resendCooldown})
                  </Typography>
                )}
              </Typography>
            </Box>
          </Paper>
        </Container>
      </Box>

      <UpdatePinDialog open={openUpdatePinDialog} data={dataOtp} handleClose={handleCloseUpdateDialog}/>
    </>
  )};

export default ForgotPin;
